<div class="input-wrapper" [ngClass]="{'input-has-icon': showIcon }">
  <label *ngIf="label">
    {{ label }} <span *ngIf="isRequired" class="required-asterisk">*</span>
  </label>
  <div *ngIf="showIcon" class="text-input-icon">
    <img class="text-input-icon-img" *ngIf="iconPath" [src]="iconPath" alt="Icon">
  </div>
  <input
    class="text-input"
    [type]="inputType"
    name="input-text"
    [maxlength]="isLengthLimited ? maxlength : null"
    [placeholder]="placeholder"
    [formControl]="control"
    (focus)="onInputFocus()"
    (focusout)="onFocusOut()"
    (blur)="control.markAsTouched()"
    (input)="onInputChanged($event)"
    [ngClass]="{
      
      'pass-char-number': ( inputType === 'tel' && (control.value?.length < 8 && control.value?.length > 0 ) && !isFocused && isTouched) || ( isLengthLimited && control.value?.length >= characterLimit && isTouched) || (control.hasError('max') || hasError('invalidUrl') || hasError('invalidPhone')|| hasError('invalidLocationFormat')|| hasError('email') ),
      'has-error': hasError('required'),
      'has-icon': showIcon,
      'number-input': inputType === 'number',
      'disabled': isDisabled
    }"
    autocomplete="off"
  />


  <div
    *ngIf="!isDisabled&&isLengthLimited && showCharacterCount && !hasError('required')"
    class="character-count"
  >
    <span *ngIf="characterLimit - control.value?.length > 0; else other_content">
      {{ characterLimit - control.value?.length }} caractères
    </span>
    <ng-template #other_content>
      Vous avez atteint la limite des caractères autorisés
    </ng-template>
  </div>

  <div *ngIf="control.hasError('max')" class="invalidInput">
    La valeur ne doit pas dépasser {{maxAcceptedDuration? maxAcceptedDuration + ' ans' : maxAcceptedAmount + " TND"}}
  </div>
 
  <span *ngIf="hasError('required') && !isDisabled" class="error-message">
    Ce champ est requis*
  </span>

  <span *ngIf="hasError('invalidUrl')" class="invalidInput">
    Veuillez entrer une URL valide (ex : https://example.com)
  </span>

  <span *ngIf="hasError('invalidLocationFormat')" class="invalidInput">
    Veuillez entrer une localisation valide (ex : 36.8065, 10.1815 ou 36°48'23"N 10°10'53"E)
  </span>

  <span *ngIf="hasError('invalidPhone')" class="invalidInput">
    Veuillez entrer un numéro de téléphone valide (+216 xx xxx xxx)
  </span>

  <span *ngIf="(inputType === 'tel' && (control.value?.length < 8 && control.value?.length >0 ) && !isFocused)" class="character-count">
    Veuillez entrer un numéro de téléphone de 8 caractères
  </span>

  <span *ngIf="hasError('email')" class="invalidInput">
    Veuillez entrer une adresse e-mail valide (ex : nom&#64;domaine.com)
  </span>

</div>
